import { render, staticRenderFns } from "./SignatureSheetTemplatesFilters.vue?vue&type=template&id=50ca0980"
import script from "./SignatureSheetTemplatesFilters.vue?vue&type=script&lang=js"
export * from "./SignatureSheetTemplatesFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports